import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import PizzaItem from './pizza-item';
import BurgerItem from './burger-item';
import SaladItem from './salad-item';
import SnakItem from './snak-item';
import DrinkItem from './drink-item';
import WokItem from './wok-item';
import LanchItem from './lanch-item';
import RollItem from './roll-item';
import { addItem, getItems } from '../../../helpers/basket';
import { offsets } from '../../../styles';
import { menuItems } from '../../../data';

const catToItemMapping = {
  pizza: PizzaItem,
  burgers: BurgerItem,
  salads: SaladItem,
  snaks: SnakItem,
  drinks: DrinkItem,
  wok: WokItem,
  rolls: RollItem,
  lanches: LanchItem,
};

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 -${offsets.sm};
`;

const Items = ({ activeCategory }) => (
  <Container>
    {menuItems[activeCategory].items.map((item, idx) =>
      catToItemMapping[activeCategory]
        ? React.createElement(catToItemMapping[activeCategory], {
            ...item,
            key: idx,
          })
        : null
    )}
  </Container>
);

Items.propTypes = {
  activeCategory: PropTypes.oneOf(Object.keys(menuItems)),
};

const mapStateToProps = ({ menu }) => ({
  activeCategory: menu.activeCategory,
});

export default connect(mapStateToProps)(Items);
